import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AlertBannerService} from './alert-banner.service';
import {Router, NavigationEnd} from '@angular/router';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-alert-banner',
  templateUrl: './alert-banner.component.pug',
  styleUrls: ['./alert-banner.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AlertBannerComponent implements OnInit {
  constructor(
    public alertList: AlertBannerService,
    public router: Router,
    private permissions: PermissionsService
  ) {}

  ngOnInit() {
    this.router.events.subscribe((val: any) => {
      if (val instanceof NavigationEnd) this.alertList.clear();
    });

    // Scroll user to top of page when new alerts are added
    this.alertList.alertsScrollTop$.subscribe(() => {
      window.scrollTo(0, 0);
    });
  }
}
